import React, { useEffect, useState } from "react";
import {
  Route,
  useLocation,
  Navigate,
  Routes,
  useParams,
} from "react-router-dom";

// for boostrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.slim";
import "popper.js/dist/umd/popper";
import "bootstrap/dist/js/bootstrap";

///GA
import i18n from './i18n';

// import { initGA, logPageView } from "./utils/analytics";
import ReactGA from 'react-ga4';
import Login from "./components/auth/login";
import Register from "./components/auth/register";
import { ScanProduct } from "./components/pages/productScan/ScanProduct";
import { OTPverification } from "./components/auth/sendotp";
import { SelectPayment } from "./components/pages/payments/SelectPayment";
import { BankDetails } from "./components/pages/payments/BankDetails";
import { UpiDetails } from "./components/pages/payments/UpiDetails";
import { ClaimDetails } from "./components/pages/myrewards";
import { ProtectedRoute } from "./components/auth/protectedRoute";
import { TransactionDetails } from "./components/pages/transactions";
import { logout, scanData, store } from "./components/auth/redux/store";
import { useDispatch } from "react-redux";
import persistStore from "redux-persist/es/persistStore";
import { PURGE } from "redux-persist";
import { Reward } from "./components/pages/reward";
import Home from "./components/pages/home";
import { useTranslation } from "react-i18next";
import { parseQueryParams } from "../src/utils";
import { TransferSucces } from "./components/pages/payments/TransferSucces";
import { decryptJSON, encryptJSON } from "./components/service/Encrtyption";
import SaltGenerator from "./components/hooks/SaltGenerator";
import { TermsandConditions } from "./components/pages/termsandconditions";
import { TermsandConditionsMbl } from "./components/pages/termsandconditions/termsandConditionsMbl";
import CustomModal from "./components/modal";
import { Button } from "react-bootstrap";
import SpinImageHi from "./assets/images/spinImage_hi.png";
import SpinImageMr from "./assets/images/spinImage_mr.png";
import SpinImageKa from "./assets/images/spinImage_ka.png";
import SpinImageTe from "./assets/images/spinImage_te.png";
import SpinImagePb from "./assets/images/spinImage_pb.png";
import SpinImageGj from "./assets/images/spinImage_gj.png";
import SpinImageTa from "./assets/images/spinImage_ta.png"; 
import SpinImageBn from "./assets/images/spinImage_bn.png"; 
import SpinImageOr from "./assets/images/spinImage_or.png"; 

import StepsImageHi from "./assets/images/hindiSteps.png";
import StepsImageMr from "./assets/images/martahiSteps.png";
import StepsImageKa from "./assets/images/kanndaSteps.png";
import StepsImageTe from "./assets/images/teluguSteps.png";
import StepsImagePb from "./assets/images/punjabiSteps.png";
import StepsImageGj from "./assets/images/gujaratiSteps.png";


function App() {
  const location = useLocation();
  const { query } = useParams();
  const dispatch = useDispatch();
  const [uParamValue, setUParamValue] = useState('');
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const { pathname } = useLocation();

  // console.log(query, "#########setvideoModal#####33");
  useEffect(() => {
    const queryString = window?.location?.href?.split("?")[1];
    const queryParams = {};
    queryString?.split("&")?.forEach((pair) => {
      const [key, value] = pair?.split("=");
      queryParams[key] = value;
    });
    const uParamValue = queryParams["u"];
    if (uParamValue !== null && uParamValue !== "" && uParamValue !== undefined) {
      const decryptedData = decryptJSON(uParamValue);
      console.log("DECRYTPDATE----------"+JSON.stringify(decryptedData));
      const jsonObject = JSON.parse(decryptedData);
      const resproductName = jsonObject.product.toLowerCase();
      sessionStorage.setItem('storedProductName', resproductName);
      sessionStorage.setItem('k', encryptJSON(queryString));
      dispatch(scanData(decryptedData));
    }

    const handleBeforeUnload = (event) => {
      sessionStorage.removeItem("userData");
      // const confirmationMessage = 'Are you sure you want to leave?';
      // event.returnValue = confirmationMessage;
      // return confirmationMessage;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [dispatch, location]);

  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const lang = pathParts[1];
    if (['mr', 'hi', 'kn', 'te', 'pa', 'gu','en','ta','bn','or'].includes(lang)) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage('hi');
    }
  }, [location]);

  useEffect(() => {
 
  if (lang === "en") {
 
    document.body.classList.remove("lang-regional");

    document.body.classList.add("lang-en");
 
  } else {
 
    document.body.classList.remove("lang-en");

    document.body.classList.add("lang-regional");
 
  }
 
}, [lang]);
 
  // UAT GA
  ReactGA.initialize('G-0BFD2LCLYT', { // updated GA 07-07-2026 
    // LIVE GA
  // ReactGA.initialize('G-JK0JJ06ERE', {  
    debug: true,
    testMode: false,
    gaAddress: 'https://ssl.google-analytics.com/ga.js',
  });

  useEffect(() => {
    // debugger;
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  useEffect(() => {
    // console.clear();
    window.scrollTo(0, 0);
  }, [pathname]);


  let bannerLogoSrc;
  if (lang === 'hi') {
    bannerLogoSrc = SpinImageHi;
  } else if (lang === 'mr') {
    bannerLogoSrc = SpinImageMr;
  } else if (lang === 'kn') {
    bannerLogoSrc = SpinImageKa;
  } else if (lang === 'te') {
    bannerLogoSrc = SpinImageTe;
  } else if (lang === 'pa') {
    bannerLogoSrc = SpinImagePb;
  } else if (lang === 'gu') {
    bannerLogoSrc = SpinImageGj;
  } else if (lang === 'ta') {
    bannerLogoSrc = SpinImageTa; 
  } else if (lang === 'bn') {
    bannerLogoSrc = SpinImageBn; 
  } else if (lang === 'or') {
    bannerLogoSrc = SpinImageOr;
  } 
  else {
    bannerLogoSrc = SpinImageHi;
  }
  ///process Img
  let StepsImg;
  if (lang === 'hi') {
    StepsImg = StepsImageHi;
  } else if (lang === 'mr') {
    StepsImg = StepsImageMr;
  } else if (lang === 'kn') {
    StepsImg = StepsImageKa;
  } else if (lang === 'te') {
    StepsImg = StepsImageTe;
  } else if (lang === 'pa') {
    StepsImg = StepsImagePb;
  } else if (lang === 'gu') {
    StepsImg = StepsImageGj;
  } else {
    StepsImg = StepsImageHi;
  }

  return (
    <>

    

      <Routes>
        {/* Fallback to default language */}
        {/* <Route path="/" element={<Navigate to="/en" replace />} /> */}

        <Route path="/" element={<Login />} />

        {/* Language-specific routes */}
        <Route path="/:lang?">
          <Route path="/:lang" element={<Login />} />
          <Route path="/:lang/login" element={<Login />} />
          <Route path="/:lang/register" element={<Register />} />
          <Route path="/:lang/verify" element={<ProtectedRoute element={<OTPverification />} />} />
          <Route path="/:lang/strongarmdhamaka" element={<TermsandConditions />} />
          <Route path="/:lang/termsandConditionsMbl" element={<TermsandConditionsMbl />} />
          {/* Catch-all route for unknown paths */}
          <Route path="*" element={<Navigate to="/en" replace />} />
        </Route>
        {/* Protected routes */}

        {/* <Route path="/:lang/home" element={<ProtectedRoute element={<Home />} />} /> */}
        <Route path="/:lang/scanproduct" requireOtp element={<ScanProduct />} />
        <Route path="/:lang/home" requireOtp element={<Home />} />
        <Route path="/:lang/paymentmode" requireOtp element={<SelectPayment />}  />
        <Route path="/:lang/upidetails" requireOtp element={<UpiDetails />} />
        <Route path="/:lang/bankdetails" requireOtp element={<BankDetails />} />
        <Route path="/:lang/Reward" requireOtp element={<Reward />} />
        <Route path="/:lang/myrewards" requireOtp element={<ClaimDetails />} />
        <Route path="/:lang/transactions" requireOtp element={<TransactionDetails />} />
        <Route path="/:lang/transferSucces" requireOtp element={<TransferSucces />} />
        <Route path="/:lang/Reward" requireOtp element={<Reward />}  />

      </Routes>

    </>



  );
}
export default App;
